import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const updateTranscriptGradesMutation = gql`
  mutation updateTranscriptGrades($input: UpdateTranscriptGradesInput!) {
    transcript {
      updateTranscriptGrades(input: $input) {
        isSuccess
        createdRecords {
          id
          name
          isCustom
          displaySequence
          associations {
            totalCount
          }
        }
        updatedRecords {
          id
          name
          isCustom
          displaySequence
          associations {
            totalCount
          }
        }
      }
    }
  }
`;

export const updateTranscriptSchoolsMutation = gql`
  mutation updateTranscriptSchools($input: UpdateTranscriptSchoolsInput!) {
    transcript {
      updateTranscriptSchools(input: $input) {
        isSuccess
        createdRecords {
          id
          name
          displaySequence
          associations {
            totalCount
          }
        }
        updatedRecords {
          id
          name
          displaySequence
          associations {
            totalCount
          }
        }
      }
    }
  }
`;

export const updateTranscriptAcademicYearsMutation = gql`
  mutation updateTranscriptAcademicYears(
    $input: UpdateTranscriptAcademicYearsInput!
  ) {
    transcript {
      updateTranscriptAcademicYears(input: $input) {
        isSuccess
        createdRecords {
          id
          label
          displaySequence
          associations {
            totalCount
          }
        }
        updatedRecords {
          id
          label
          displaySequence
          associations {
            totalCount
          }
        }
      }
    }
  }
`;

export const updateTranscriptGradingPeriodsMutation = gql`
  mutation updateTranscriptGradingPeriods(
    $input: UpdateTranscriptGradingPeriodsInput!
  ) {
    transcript {
      updateTranscriptGradingPeriods(input: $input) {
        isSuccess
        createdRecords {
          id
          name
          isCustom
          displaySequence
          source {
            ... on AcademicTerm {
              id
              curriculumProgram {
                id
              }
              academicYear {
                id
              }
            }
          }
          associations {
            totalCount
          }
        }
        updatedRecords {
          id
          name
          isCustom
          displaySequence
          source {
            ... on AcademicTerm {
              id
              curriculumProgram {
                id
              }
              academicYear {
                id
              }
            }
          }
          associations {
            totalCount
          }
        }
      }
    }
  }
`;

export const upsertTranscriptStudentGradeMappingMutation = gql`
  mutation upsertTranscriptStudentGradeMappingMutation(
    $input: UpsertTranscriptStudentGradeMappingInput!
  ) {
    transcript {
      upsertTranscriptStudentGradeMapping(input: $input) {
        isSuccess
        warning
        records {
          id
          student {
            id
          }
          grade {
            id
          }
        }
      }
      __typename
    }
  }
`;

export const updateTranscriptStudentGradeGradingPeriodMappingMutation = gql`
  mutation updateTranscriptStudentGradeGradingPeriodMapping(
    $input: UpdateTranscriptStudentGradeGradingPeriodMappingInput!
  ) {
    transcript {
      updateTranscriptStudentGradeGradingPeriodMapping(input: $input) {
        isSuccess
      }
    }
  }
`;

export const bulkCopyTranscriptGradeLevelsMutation = gql`
  mutation BulkCopyTranscriptGradeLevels(
    $input: BulkCopyTranscriptGradeLevelsInput!
  ) {
    transcript {
      bulkCopyTranscriptGradeLevels(input: $input) {
        isSuccess
        skipped {
          student {
            ...userNameFields
            profileImage
          }
          errors {
            errorType
            grades {
              id
              name
            }
          }
        }
        applied {
          student {
            ...userNameFields
            profileImage
          }
          grades {
            id
            name
          }
        }
        __typename
      }
      __typename
    }
  }
  ${userNameFragment}
`;
